export default __webpack_public_path__ + "50f2b18088ed9636bd9d7411dfcdc60f.woff";